import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  height: string;
  outcome?: string;
  delay?: number;
}
export function TestimonialCard({
  quote,
  author,
  height,
  outcome,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-card p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-319">
      <Quote className="w-8 h-8 text-accent/40 mb-6" data-id="element-320" />
      <p className="text-lg text-text-primary leading-relaxed mb-6 flex-grow font-serif italic" data-id="element-321">
        "{quote}"
      </p>
      <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-322">
        <p className="font-semibold text-text-primary" data-id="element-323">{author}</p>
        <div className="flex items-center text-sm text-text-muted mt-1 space-x-2" data-id="element-324">
          <span data-id="element-325">{height}</span>
          {outcome && <>
              <span className="w-1 h-1 bg-accent rounded-full" data-id="element-326"></span>
              <span data-id="element-327">{outcome}</span>
            </>}
        </div>
      </div>
    </motion.div>;
}